import { useCallback } from 'react';
import _ from 'underscore';
import { useLocation } from 'react-router-dom';

import { WAITING_MESSAGE_TYPES, WAITING_MESSAGE_DISABLE_ALL } from './constants';

export const useGetWelcomeWaitingMessageTypes = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const disableWaitingMessageSubscriptions = searchParams.get('disableWaitingMessageSubscriptions');

    return useCallback(({ excludeWaitingMessages = '' } = {}) => {
        if (disableWaitingMessageSubscriptions === 'all') {
            return WAITING_MESSAGE_DISABLE_ALL;
        }

        const decodedDisableMessageSubscriptions = decodeURIComponent(`${disableWaitingMessageSubscriptions},${excludeWaitingMessages}`);

        return _.difference(WAITING_MESSAGE_TYPES.split(',') || [], decodedDisableMessageSubscriptions.split(',')).join(',');
    }, [disableWaitingMessageSubscriptions]);
};
